exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-plasmic-host-tsx": () => import("./../../../src/pages/plasmic-host.tsx" /* webpackChunkName: "component---src-pages-plasmic-host-tsx" */),
  "component---src-templates-default-plasmic-page-tsx": () => import("./../../../src/templates/defaultPlasmicPage.tsx" /* webpackChunkName: "component---src-templates-default-plasmic-page-tsx" */)
}

